<div class="bg-white px-4">
    <header class="mb-10 flex items-center px-8 pt-10">
        <div class="flex items-center">
            <mat-icon
                class="mr-5 scale-150"
                fontSet="material-symbols-outlined">
                ad
            </mat-icon>
            <h1 class="text-3xl font-medium">Banners</h1>
        </div>
    </header>
    @if (bannersStore.isFulfilled()) {
        <button
            mat-flat-button
            color="primary"
            (click)="openEditBanner()">
            Add banner
        </button>
        <table
            mat-table
            [dataSource]="dataSource">
            <ng-container matColumnDef="provider">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Provider
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    {{ BannerProvider[element.provider] }}
                </td>
            </ng-container>
            <ng-container matColumnDef="countries">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Countries
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        {{ element.allowedCountries }}
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="active">
                <th
                    mat-header-cell
                    *matHeaderCellDef>
                    Active
                </th>
                <td
                    mat-cell
                    *matCellDef="let element">
                    <div class="flex items-center">
                        <mat-checkbox
                            disabled
                            [checked]="element.isActive"></mat-checkbox>
                    </div>
                </td>
            </ng-container>
            <ng-container matColumnDef="actions">
                <th
                    mat-header-cell
                    *matHeaderCellDef></th>
                <td
                    class="self-end"
                    mat-cell
                    *matCellDef="let element">
                    <button
                        mat-button
                        (click)="openEditBanner(element)">
                        Edit banner
                    </button>
                </td>
            </ng-container>
            <tr
                mat-header-row
                *matHeaderRowDef="displayedColumns()"></tr>
            <tr
                mat-row
                *matRowDef="let row; columns: displayedColumns()"></tr>
        </table>
    }
</div>
